import React from 'react'
import RouterMap from './routerMap'
import {HashRouter,Route,Switch} from 'react-router-dom'
import SamePartHead from "../../pages/samePart/samePart_head";
import Error from '../../pages/404/index'
import Axios from "../request/axios";
//https://www.npmjs.com/package/react-animated-router/v/0.1.11  动画组件参考文档
import AnimatedRouter from 'react-animated-router'; //导入我们的的AnimatedRouter组件
import 'react-animated-router/animate.css'; //导入默认的切换动画样式，如果需要其它切换样式，可以拷贝一份，写入自己的动画样式定义文件再引用
import Login_new from '../../pages/login/login_new' //扫码登录界面
// import Login_new from '../../pages/login/login' ////用户名密码登录界面
//import Reset from '../../pages/reset/login'
import {IsPC} from "../IsPc";
import getIdFromUrl from "../getIdFromUrl";
import SuccessLogin from "../../pages/successLogin";

class RouterIndex extends React.Component{
    state={
        menus:[///菜单列表默认有的，其他的从接口获取
            {
                name:'首页',
                hash:'#/',
                key:'index',
                iconfont:'iconfont iconcangpeitubiao-shouye'
            }, {
                name:'治疗方案',
                hash:'#/treatments',
                key:'treatments',
                iconfont:'iconfont iconfanganku'
            },{
                name:'论坛',
                hash:'#/tribune',
                key:'tribune',
                iconfont:'iconfont iconluntanzhongxin'
            }
        ]
    };
    componentDidMount() {
        let _this=this;
        let menus=[...this.state.menus];
        let indexNum=2;///pc端动态菜单默认添加的位置
        if(!IsPC()){//手机端显示，不加载论坛路由
            indexNum=1;///手机端添加菜单的位置
            this.setState({
                menus:[///菜单列表默认有的，其他的从接口获取
                    {
                        name:'首页',
                        hash:'#/',
                        key:'index',
                        iconfont:'iconfont iconcangpeitubiao-shouye'
                    }, {
                        name:'治疗方案',
                        hash:'#/treatments',
                        key:'treatments',
                        iconfont:'iconfont iconfanganku'
                    }
                ]
            });
            menus=[///菜单列表默认有的，其他的从接口获取
                {
                    name:'首页',
                    hash:'#/',
                    key:'index',
                    iconfont:'iconfont iconcangpeitubiao-shouye'
                }, {
                    name:'治疗方案',
                    hash:'#/treatments',
                    key:'treatments',
                    iconfont:'iconfont iconfanganku'
                }
            ]
        }
        let userInfo=window.localStorage.getItem('userInfo');
        ///控制权限，数据库模块，治疗方案模块的新增按钮
        if(IsPC()&&userInfo&&JSON.parse(userInfo).grade_name&&(getIdFromUrl(JSON.parse(userInfo).grade_name)==='1'||getIdFromUrl(JSON.parse(userInfo).grade_name)==='2')){//pc端并且登录了,并且是
            let data={
                name:'数据库',
                hash:'#/cases',
                key:'cases',
                iconfont:'iconfont iconyisheng'
            };
            menus.splice(1,0,data);//添加数据库
            indexNum=3;
        }
        Axios.get('/api/v1/channel/').then((res)=> {// 请求channel，动态获取文章类的菜单
            if(res){
                let results=res.results;
                let hideMenus=[];
                results.map((item,index)=>{
                    if(item.is_show&&item.level === 0){ ///文章类的动态的菜单，路由都是news
                        let data={
                            name:item.name,
                            hash:'#/news',
                            key:item.id.toString(),
                            iconfont:item.fontawesome_icon_class
                        };
                        if(item.name==='合作伙伴'){
                            menus.splice(menus.length,0,data);//将获取的合作伙伴菜单添加到menus的最后位置
                        }else {
                            menus.splice(menus.length - indexNum,0,data);//将获取的菜单添加到menus里
                        }
                        let arrIndex=menus.indexOf(data);///获取新增菜单在数组中的位置
                        _this.setState({menus});
                        window.localStorage.setItem('menus',JSON.stringify(menus));

                        let params2={
                            parent__id:item.id
                        };
                        Axios.get('/api/v1/channel/',params2).then((res2)=>{///获取第二层的菜单
                            if(res2){
                                if(res2.results.length > 0){
                                    menus[arrIndex].children=[];
                                    res2.results.map((item2,index2)=>{
                                        let data2={
                                            name:item2.name,
                                            hash:'#/news',
                                            key:item2.id.toString(),
                                            iconfont:item2.fontawesome_icon_class
                                        };
                                        menus[arrIndex].children.push(data2);

                                        let arrIndex2=menus[arrIndex].children.indexOf(data2);///获取新增菜单在数组中的位置

                                        _this.setState({menus});
                                        window.localStorage.setItem('menus',JSON.stringify(menus));

                                        let params3={
                                            parent__id:item2.id
                                        };
                                        Axios.get('/api/v1/channel/',params3).then((res3)=>{///获取第三层的菜单
                                            if(res3){
                                                if(res3.results.length > 0){
                                                    menus[arrIndex].children[arrIndex2].children=[];
                                                    res3.results.map((item3,index3)=>{
                                                        let data3={
                                                            name:item3.name,
                                                            hash:'#/news',
                                                            key:item3.id.toString(),
                                                            iconfont:item3.fontawesome_icon_class
                                                        };
                                                        menus[arrIndex].children[arrIndex2].children.push(data3);

                                                        _this.setState({menus});
                                                        window.localStorage.setItem('menus',JSON.stringify(menus));

                                                        let arrIndex3=menus[arrIndex].children[arrIndex2].children.indexOf(data3);///获取新增菜单在数组中的位置
                                                        let params4={
                                                            parent__id:item3.id
                                                        };
                                                        Axios.get('/api/v1/channel/',params4).then((res4)=>{///获取第四层的菜单
                                                            if(res4){
                                                                if(res4.results.length > 0){
                                                                    menus[arrIndex].children[arrIndex2].children[arrIndex3].children=[];
                                                                    res4.results.map((item4,index4)=>{
                                                                        let data3={
                                                                            name:item4.name,
                                                                            hash:'#/news',
                                                                            key:item4.id.toString(),
                                                                            iconfont:item4.fontawesome_icon_class
                                                                        };
                                                                        menus[arrIndex].children[arrIndex2].children[arrIndex3].children.push(data3);

                                                                        _this.setState({menus});
                                                                        window.localStorage.setItem('menus',JSON.stringify(menus));

                                                                        return item4
                                                                    })
                                                                }
                                                            }
                                                        });
                                                        return item3
                                                    })
                                                }
                                            }
                                        });
                                        return item2
                                    })
                                }
                            }
                        });
                    }else if(!item.is_show&&item.level === 0){///第一层菜单，并且隐藏的 适用于文章推荐  党的精神图片,貌似废弃了，没有用到
                        let data={
                            name:item.name,
                            hash:'#/news',
                            key:item.id.toString(),
                            iconfont:item.fontawesome_icon_class
                        };
                        hideMenus.push(data);
                        window.localStorage.setItem("hideMenus",JSON.stringify(hideMenus));
                    }
                    return item
                });
            }
        })
    }
    toSetMenus=()=>{
        let menus=[...this.state.menus];
        let userInfo=window.localStorage.getItem('userInfo');
        if(IsPC()&&userInfo&&JSON.parse(userInfo).grade_name&&(getIdFromUrl(JSON.parse(userInfo).grade_name)==='1'||getIdFromUrl(JSON.parse(userInfo).grade_name)==='2')){//登录了并且是电脑端
            let isHave=false;
            for(let i=0;i<menus.length;i++){
                if(menus[i].name==='数据库'){//有数据库
                    isHave=true;
                    break;
                }
            }
            if(!isHave){///没有数据库
                let data={
                    name:'数据库',
                    hash:'#/cases',
                    key:'cases',
                    iconfont:'iconfont iconyisheng'
                };
                menus.splice(menus.length-2,0,data);//添加数据库菜单
                this.setState({
                    menus
                })
            }
        }else {
            for(let i=0;i<menus.length;i++){
                if(menus[i].name==='数据库'){//有数据库
                    menus.splice(i,1);//删除数据库菜单
                    this.setState({
                        menus
                    });
                    break;
                }
            }
        }
    };
    render(){
        let {menus}=this.state;
        return (
            // 根容器
            <HashRouter>
                <div style={{width:'100%',height:'100%',position:'relative'}}>
                   {/* <Header/>*/}
                    {/* 路由规则，Route是配置路由的规则，同时也是一个占位符 */}
                        <Switch>
                            <Route exact key='/login' path='/login'  >
                                <Login_new toSetMenus={this.toSetMenus.bind(this)}/>
                            </Route>
                           {/* <Route exact key='/reset' path='/reset'  >
                                <Reset toSetMenus={this.toSetMenus.bind(this)}/>
                            </Route>*/}
                            <Route exact key='/success_login' path='/success_login'  >
                                <SuccessLogin toSetMenus={this.toSetMenus.bind(this)} />
                            </Route>
                            <Route key='/'>
                                <SamePartHead menus={menus} toSetMenus={this.toSetMenus.bind(this)}>
                                    <AnimatedRouter >
                                        {RouterMap.map((item,index)=>{
                                            if(item.name==='index'){
                                                return  <Route exact key={index} path={item.path} component={item.component}/>
                                            }else {
                                                return  <Route  exact key={index} path={item.path} component={item.component}/>
                                            }
                                        })}

                                        {/*匹配不到路由的时候跳转到404*/}
                                        <Route component={Error} />
                                    </AnimatedRouter>
                                </SamePartHead>
                            </Route>
                            {/*匹配不到路由的时候跳转到404*/}
                            <Route component={Error} />
                        </Switch>
                </div>
            </HashRouter>
        );
    }
}

export default RouterIndex;